module.exports = "fragment FontFragment on Font {\n  id\n  displayName\n  fontName\n  ttfFile\n  isSig\n}\n"